import { FC } from 'react'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import { toAbsoluteUrl } from 'src/_metronic/helpers'

interface Props {
    reviewers: any[]
    approvers: any[]
}

export const ApprovalHistoryPreview: FC<Props> = ({
    reviewers,
    approvers
}) => {

    const bgStatuses = [
        {
            status: 'reviewer',
            bg: '#eee',
            color: '',
            icon: 'clock'
        },
        {
            status: 'reviewed',
            bg: 'green',
            color: 'white',
            icon: 'check'
        },
        {
            status: 'reviewer-reject',
            bg: 'red',
            color: 'white',
            icon: 'close'
        },
        //
        {
            status: 'approver',
            bg: '#eee',
            color: '',
            icon: 'clock'
        },
        {
            status: 'approved',
            bg: 'green',
            color: 'white',
            icon: 'check'
        },
        {
            status: 'approver-reject',
            bg: 'red',
            color: 'white',
            icon: 'close'
        },
    ];

    return <div className='d-flex justify-content-between tracking-hz'>
        {[
            ...reviewers,
            ...approvers
        ].map((reviewer: any, key: number) => {
            let status = bgStatuses?.find((item: any) => item.status == reviewer?.status);

            return <>
                <div className='d-flex text-center flex-column align-items-center tracking-hz-item'>
                    <OverlayTrigger
                        trigger={['hover', 'focus']}
                        key={key}
                        placement='bottom'
                        overlay={
                            <Popover id={`popover-positioned-${key}`}>
                                <Popover.Body><b>{reviewer?.name}</b>
                                    {reviewer?.approve_date && <>
                                        <br /><i>{reviewer?.approve_date}</i>
                                    </>
                                    }</Popover.Body>
                            </Popover>
                        }
                    >
                        <div style={{
                            width: '30px',
                            height: '30px',
                            borderRadius: '50%',
                            background: status?.bg,
                            color: status?.color
                        }} className='d-flex align-items-center justify-content-center mb-3'>
                            <i className={'fa fa-' + status?.icon}></i>
                        </div>
                    </OverlayTrigger>
                    <b>{reviewer?.username}</b>
                </div>

                {key < (reviewers.length + approvers.length) - 1 && <>
                    <div className='tracking-hz-separator'></div>
                </>}
            </>
        })}
    </div>
}